module.exports = __webpack_public_path__ + "fonts/question-answer-gray.svg";